import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class Select extends React.Component {
  render() {
    const props = this.props
    const options = props.options.map((op, index) => (
      <option
        key={index}
        value={op.value}
        disabled={op.disabled}
        hidden={op.hidden}
      >
        {op.name}
      </option>
    ))
    return (
      <div
        className={classNames({
          'form-field': true,
          'select-field': true,
          'has-error': props.hasError,
          [props.theme]: true,
          [props.className]: props.className
        })}
        disabled={props.disabled}
      >
        <select
          autoComplete={'off'}
          className={'select'}
          name={props.name}
          id={props.id}
          defaultValue={props.defaultValue}
          value={props.value}
          onSubmit={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          disabled={props.disabled}
        >
          {options}
        </select>
        <label className='form-label' htmlFor={props.id}>
          {props.label}
        </label>
      </div>
    )
  }
}

Select.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultValue: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      name: PropTypes.string
    })
  ),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  hasError: PropTypes.bool,
  hasText: PropTypes.bool,
  disabled: PropTypes.bool,
  theme: PropTypes.oneOf(['light-theme', 'dark-theme']),
  className: PropTypes.string
}

Select.defaultProps = {
  theme: 'light-theme',
  options: [{ name: 'option1', value: 'option1' }]
}

export default Select



// WEBPACK FOOTER //
// ./src/ui/forms/select.js